import { CloseOutlined, CloseRounded, HighlightOff } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, Box, Typography, Avatar } from '@mui/material';

export default function IdCardDialog({
  open,
  onClose,
  title = 'ID Card',
  logo,
  backgroundImage,
  profileImage,
  firstName,
  lastName,
  bloodGroup,
  emergencyContact,
  address,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: 0,
          borderRadius: 3,
        },
      }}
    >
      {/* Title */}
      <DialogTitle
        sx={{
       
          display: 'flex',
          backgroundColor: '#f9cf44ff',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
          borderBottom: '1px solid #ddd',
        }}
      >
        <Typography sx={{fontWeight:600}}> {title} </Typography>

        <HighlightOff sx={{ cursor: 'pointer' }} onClick={onClose} />
      </DialogTitle>

      {/* Content */}
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: 2,
          mt: 2,
        }}
      >
        {/* ID CARD */}
        <Box
          sx={{
            width: 280,
            borderRadius: 2,
            boxShadow: 3,
            overflow: 'hidden',
            background: '#fff',
            border: '1px solid #ddd',
            position: 'relative',
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: '110% 75%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        >
          {/* Left Color Strips */}
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: 18,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box sx={{ flex: 1, background: '#f9cf44ff' }} />
            <Box sx={{ flex: 1, background: '#fa673aff' }} />
            <Box sx={{ flex: 1, background: '#1c1b1bff' }} />
          </Box>

          {/* Main Content */}
          <Box
            sx={{
              pl: 4,
              pr: 2,
              py: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {/* Logo */}
            <img src={logo} alt="logo" style={{ height: 65, marginBottom: 8 }} />

            {/* Profile */}
            <Avatar
              src={profileImage}
              sx={{
                width: 100,
                height: 100,
                border: '3px solid #d32f2f',
                mb: 1,
                img: { objectFit: 'cover', objectPosition: 'top' },
              }}
            />

            {/* Name */}
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              {firstName} {lastName}
            </Typography>

            {/* Details */}
            <Box sx={{ textAlign: 'center', fontSize: 14 }}>
              {bloodGroup && (
                <Typography>
                  Blood Group: <b>{bloodGroup}</b>
                </Typography>
              )}

              {emergencyContact && (
                <>
                  <Typography sx={{ mt: 1 }}>Emergency Contact No.</Typography>
                  <Typography sx={{ fontSize: 16, fontWeight: 600 }}>{emergencyContact}</Typography>
                </>
              )}

              {address && (
                <Box
                  sx={{
                    display: 'flex',
                    mt: 2,
                    justifyContent: 'center',
                  }}
                >
                  <Box sx={{ mr: 1, textAlign: 'left' }}>
                    <Typography sx={{ fontSize: 12, fontWeight: 700 }}>Permanent</Typography>
                    <Typography sx={{ fontSize: 12, fontWeight: 700 }}>Address</Typography>
                  </Box>

                  <Box sx={{ width: 150, textAlign: 'left' }}>
                    <Typography sx={{ fontSize: 12, lineHeight: 1.2 }}>{address}</Typography>
                  </Box>
                </Box>
              )}
            </Box>

            {/* Footer */}
            <Typography
              sx={{
                mt: 2,
                fontSize: 10,
                color: 'grey.600',
                textAlign: 'center',
              }}
            >
              A SOFTWARE ENGINEERING COMPANY
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
